import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Product } from 'src/app/stores/product.store';

@Component({
  selector: 'app-no-product',
  templateUrl: './no-product.component.html',
  styleUrls: ['./no-product.component.scss'],
})
export class NoProductComponent implements OnInit {
  @Input() products: Array<Product>;
  constructor(private router: Router, public platform: Platform) {}
  ngOnInit() {}

  productRedirect(id) {
    this.router.navigate([`/product/${id}`]);
  }
}
